/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Start_C_DInputs */

const en_wc_start_c_d = /** @type {(inputs: Wc_Start_C_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use File → Save or Ctrl/Cmd + S to keep a copy on your device. Check the saved file and review the layout when exchanging documents with Microsoft Word.`)
};

/**
* | output |
* | --- |
* | "Use File → Save or Ctrl/Cmd + S to keep a copy on your device. Check the saved file and review the layout when exchanging documents with Microsoft Word." |
*
* @param {Wc_Start_C_DInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_start_c_d = /** @type {((inputs?: Wc_Start_C_DInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Start_C_DInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_start_c_d(inputs)
});
export { wc_start_c_d as "wc.start.c_d" }